import {
  ExperimentStatusDefinition,
  ExperimentStatusTab,
  EXPERIMENT_ANALYTICS_TAB,
  TabType,
} from '../types';

export const ALL_EXPERIMENT_STATUSES = Object.values(ExperimentStatusDefinition);

export const EXPERIMENT_STATUS_FILTER: ExperimentStatusTab[] = [
  {
    id: ALL_EXPERIMENT_STATUSES,
    label: 'tabFilter.all',
  },
  {
    id: [ExperimentStatusDefinition.Draft],
    label: 'tabFilter.draft',
  },
  {
    id: [ExperimentStatusDefinition.Running],
    label: 'tabFilter.running',
  },
  {
    id: [ExperimentStatusDefinition.Finished],
    label: 'tabFilter.finished',
  },
  {
    id: [ExperimentStatusDefinition.Errored],
    label: 'tabFilter.errored',
  },
];

export const EXPERIMENT_MONITOR_TABS: TabType[] = [
  {
    id: EXPERIMENT_ANALYTICS_TAB.OVERVIEW,
    label: 'monitor.tab.overview',
  },
  {
    id: EXPERIMENT_ANALYTICS_TAB.PERFORMANCE,
    label: 'monitor.tab.performance',
  },
];
